import { useMutation, gql } from '@apollo/react-hooks';
import { useCallback } from 'react';
import type { CreateCapitalNeedMutation, CapitalNeedInput } from '#/graphql/types';
import { createCapitalNeed } from '#/graphql/mutations';
import { get } from 'lodash';

const q = gql(createCapitalNeed);

const useCapitalNeedCreate = () => {
  const [mutation, result] = useMutation<CreateCapitalNeedMutation>(q);
  const createCapitalNeed = useCallback(
    async (data: CapitalNeedInput) => {
      const response = await mutation({
        variables: {
          data,
        },
      });

      const result = get(response, 'data.createCapitalNeed', undefined);

      if (result && result.status !== 200) {
        const errorMessage = result.errors?.join('\n') || 'Create failed';
        throw new Error(errorMessage);
      }

      return result;
    },
    [mutation],
  );

  return { createCapitalNeed, result };
};

export default useCapitalNeedCreate;
